export const PAGE_ID = 'rememberMeAccountSelectScreen' as const;
